import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
// import { useHistory } from 'react-router-dom'
// import { useHistory } from 'react-router-dom'
// import "../../styles/manageAccount/manageAccount.scss"
import "../../styles/manageAccount/manageAccount.css"
import { PostRequest, getImgPath } from '../common/helper'
import BusTicketBooking from './BusTicketBooking'
import CardList from './CardList'
import EditProfile from './EditProfile'
import { renderSvg } from './renderSvg'
import HeaderNew from '../header/HeaderNew'
import Footer from '../footer/footer'
import SubHeader from '../header/subHeader'
import HeaderNonSrp from '../header/headerNonSrp'
import { apiUrl } from '../common/constants'
import AccountLoader from './accountLoader'
import Confirmation from '../common/confirmation'
import AlertFail from '../common/alertFail';
import AlertSuccess from '../common/alertSuccess'
import { renderImg } from '../common/icons/img'
import { ACCOUNT_DELETED, ACCOUNT_DELETE_CONFIRMATION, ACCOUNT_DELETE_ERROR, DELETED_CONFITMATION, DELETE_FAILURE, DELETE_YOUR_PROFILE, EDIT_YOUR_PROFILE, LOG_OUT, t } from '../../translations/ManageAccount/ManageAccount'
import { tCommon, BUS_TICKET_BOOKING, BUS_TRUCK_HIRE, CARGO_BOOKING, TOUR_PACKAGE_BOOKING } from '../../translations/Common'
// import { useHistory } from 'react-router-dom';
import Recaptcha_v3 from '../recaptcha_v3'

const ManageAccount = (props) => {
    const { search } = props

    const handleClick = () => {
        // Navigate to a different route upon button click
        setTabs(0)
        //   history.push("/manageAccount/busTcktBooking");
    };
    // const []
    const [tabs, setTabs] = useState(4)
    const [leftTabs, setLeftTabs] = useState(0);
    const urlParams = new URLSearchParams(window.location.search);
    const cancel = urlParams.get("cancel");
    const enquiry = urlParams.get("enquiry")
    const profile = urlParams.get("profile");
    const [loader, setLoader] = useState(false);

    const [confirmation, setConfirmation] = useState(false);
    const [deleteFail, setDeleteFail] = useState(false);
    const [deleteSuccess, setDeleteSuccess] = useState(false);


    useEffect(() => {
        if (cancel || enquiry) {
            setTabs(0);
        }
        if (profile) {
            setTabs(4)
        }
    }, [])


    const deleteProfile = () => {

        setConfirmation(false);
        const data = {
            token: window.customerProfile.token,
        };
        setLoader(true);
        PostRequest(apiUrl.deleteProfile, data)
            .then((res) => {
                setLoader(false)
                if (res.Success) {
                    //window.location.href = "/";
                    setDeleteSuccess(true);
                } else {
                    setLoader(false);
                    setDeleteFail(true);
                }
            })
            .catch((err) => { setLoader(false) });
    }

    return (
        <div>
            <HeaderNonSrp />
            <SubHeader />
            {loader && <AccountLoader />}
            <div className='manage-container'>
                <div className="manage-Tabs">
                    <div className={`tabs ${tabs == 0 && "active"}`} onClick={() => handleClick()}>
                        {renderSvg("mitra")}
                        <span className="header-right-item-text">{tCommon(BUS_TICKET_BOOKING)}</span>
                    </div>
                    {/* 
                    <div className={`tabs ${tabs == 1 && "active"}`} onClick={() => setTabs(1)}>
                        {renderSvg("TourPack")}
                        <span className="header-right-item-text">{tCommon(TOUR_PACKAGE_BOOKING)}</span>
                    </div>
                    <div className={`tabs ${tabs == 2 && "active"}`} onClick={() => setTabs(2)}>
                        {renderSvg("BusTruck")}
                        <span className="header-right-item-text">{tCommon(BUS_TRUCK_HIRE)} </span>
                    </div>
                    <div className={`tabs ${tabs == 3 && "active"}`} onClick={() => setTabs(3)}>
                        {renderSvg("cargoBkg")}
                        <span className="header-right-item-text">{tCommon(CARGO_BOOKING)}</span>
                    </div>*/}
                    <div className={`tabs ${tabs == 4 && "active"}`} onClick={() => setTabs(4)}>
                        {renderSvg("editProfile")}
                        <span className="header-right-item-text">{t(EDIT_YOUR_PROFILE)}</span>
                    </div>
                    <div className={`tabs ${tabs == 5 && "active"}`} onClick={() => { setTabs(5); setConfirmation(true) }}>
                        {renderSvg("deleteProfile")}
                        <span className="header-right-item-text">{t(DELETE_YOUR_PROFILE)}</span>
                    </div>
                    <div className={`tabs ${tabs == 6 && "active"}`} onClick={() => { setTabs(6); window.location.href = "/welcome/logout" }}>
                        {renderSvg("logOut")}
                        <span className="header-right-item-text">{t(LOG_OUT)}</span>
                    </div>
                </div>
                {
                    tabs == 0 && <BusTicketBooking />
                }
                {
                    tabs == 4 && <EditProfile setTabs={setTabs} />
                }
                {/* {search.loader ? (
                    <div className="show-load">
                        <div className="loading">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                ) : (
                    ""
                )} */}
                {/* <div className="mainContent">
                <div className="leftContent">
                    <div className="leftTabs">
                        <div className={`tabsContent ${leftTabs == 0 && "active"}`} onClick={() => setLeftTabs(0)}>
                            {renderSvg("mitra")}
                            <span className="header-right-item-text">Manage Bus Booking</span>
                        </div>
                        <div className={`tabsContent ${leftTabs == 1 && "active"}`} onClick={() => setLeftTabs(1)}>
                            {renderSvg("TourPack")}
                            <span className="header-right-item-text">&nbsp;  Bus PNR Enquiry</span>
                        </div>
                        <div className={`tabsContent ${leftTabs == 2 && "active"}`} onClick={() => setLeftTabs(2)}>
                            {renderSvg("BusTruck")}
                            <span className="header-right-item-text">Transaction Enquiry</span>
                        </div>
                        <div className={`tabsContent ${leftTabs == 3 && "active"}`} onClick={() => setLeftTabs(3)}>
                            {renderSvg("cargoBkg")}
                            <span className="header-right-item-text">Bus Service Enquiry</span>
                        </div>
                    </div>
                </div>
                <div className="rightContent">
                    {leftTabs == 0 && <CardList />}

                </div>
            </div> */}

            </div>
            <Footer />
            {confirmation && (
                <Confirmation
                    msg={
                        <div
                            className="tnc-block-text"
                            style={{ justifyContent: "center" }}
                        >
                            <div className="icon">
                                {renderImg('close_icon')}
                            </div>
                            <div className="content" style={{ fontSize: '14px', fontWeight: '500', lineHeight: '22px', color: '#202020', padding: '16px 0' }}>
                                {t(ACCOUNT_DELETE_CONFIRMATION)}
                            </div>
                        </div>
                    }
                    noAction={() => setConfirmation(false)}
                    yesAction={deleteProfile}
                />
            )}
            {deleteSuccess && <AlertSuccess
                msg={
                    <div
                        className="tnc-block-text"
                        style={{ justifyContent: "center" }}
                    >
                        <div className="icon">
                            {renderImg('success_icon')}
                        </div>
                        <div style={{ color: '#3C763C', fontSize: '20px', fontWeight: '500', lineHeight: '28px', textAlign: 'center', padding: '16px 0' }}>{t(ACCOUNT_DELETED)} !</div>
                        <div className="content" style={{ fontSize: '14px', fontWeight: '500', lineHeight: '22px', color: '#202020' }}>
                            {t(DELETED_CONFITMATION)}
                        </div>
                    </div>
                }
            />}
            {deleteFail && <AlertFail
                msg={
                    <div
                        className="tnc-block-text"
                        style={{ justifyContent: "center" }}
                    >
                        <div className="icon">
                            {renderImg('fail_icon')}
                        </div>
                        <div style={{ color: '#F05924', fontSize: '20px', fontWeight: '500', lineHeight: '28px', textAlign: 'center', padding: '16px 0' }}>{t(DELETE_FAILURE)}</div>
                        <div className="content" style={{ fontSize: '14px', fontWeight: '500', lineHeight: '22px', color: '#202020' }}>
                            {t(ACCOUNT_DELETE_ERROR)} !

                        </div>
                    </div>
                }

            />}
            <Recaptcha_v3/>
        </div>
    )
}

const mapStateToProps = function (store) {
    return store;
};

export default connect(mapStateToProps)(ManageAccount);
// export default 